import type { AxiosInstance } from 'axios';

import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  true: 'Yes',
  false: 'No',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Asset private flag
 * Translates between API boolean values and UI user-friendly strings
 */
export const AssetPrivate: SimpleFilterDefinition = {
  apiField: 'private',
  uiField: 'Private',
  inputType: 'dropdown',
  getAvailableValues: (_axios: AxiosInstance) => Promise.resolve(['Yes', 'No']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Private',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    const stringValue = getValueFromSimpleFilter(valueMapInverse, simpleFilter);
    const boolValue = stringValue === 'true';

    return {
      field: 'private',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: boolValue,
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
